import { Repeat2, Building2, Home, Store } from "lucide-react";
import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import Reveal from "@/components/Reveal";
import CtaSection from "@/components/CtaSection";
import { COMMERCIAL_SEGMENTS } from "@/data/site";

const ICONS = {
  turnovers: Repeat2,
  "property-managers": Building2,
  realtors: Home,
  commercial: Store,
};

export default function Commercial() {
  return (
    <>
      <Seo
        title="Commercial & Property Management Cleaning Greensboro NC | Authentically Yours"
        description="Apartment turnovers, property-management cleaning, realtor pre-listing cleaning and commercial cleaning in Greensboro, NC. Custom quotes and free estimates."
        path="/commercial"
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "Commercial", path: "/commercial" },
        ]}
      />
      <PageHero
        eyebrow="Property Professionals"
        title="Property Services That Work Around Your Business"
        intro="From apartment turnovers and rental properties to offices and commercial spaces, we help property managers, apartment communities, realtors and businesses keep spaces clean, presentable and ready for what's next."
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "Commercial", path: "/commercial" },
        ]}
      />

      <div className="container-x py-20 sm:py-28 grid gap-6 md:grid-cols-2">
        {COMMERCIAL_SEGMENTS.map((seg, i) => {
          const Icon = ICONS[seg.id] || Building2;
          return (
            <Reveal key={seg.id} delay={(i % 2) * 0.08}>
              <article className="h-full card-lift bg-white border border-gold/20 p-8 lg:p-10 hover:border-rose/40">
                <span className="inline-flex h-14 w-14 items-center justify-center border border-rose/30 text-rose mb-6" aria-hidden="true">
                  <Icon size={26} strokeWidth={1.25} />
                </span>
                <h2 className="text-3xl text-ink">{seg.title}</h2>
                <ul className="mt-5 grid gap-2.5">
                  {seg.items.map((it) => (
                    <li key={it} className="flex items-start gap-3 text-ink/75">
                      <span className="mt-2 h-1.5 w-1.5 rounded-full bg-rose shrink-0" aria-hidden="true" />
                      {it}
                    </li>
                  ))}
                </ul>
              </article>
            </Reveal>
          );
        })}
      </div>

      <div className="container-x pb-8">
        <Reveal className="bg-blush-soft/60 border border-gold/25 p-6 text-sm text-ink/70 max-w-3xl">
          Commercial and property-management work is quoted per property. Pricing is
          provided as a <span className="text-ink font-medium">custom quote / free estimate</span> based
          on your scope — no fixed prices to guess at.
        </Reveal>
      </div>

      <CtaSection
        title="Request a Commercial Estimate"
        text="Tell us about your properties and scope of work and we'll follow up with a custom quote."
        estimateLabel="Request a Commercial Estimate"
      />
    </>
  );
}
